import {Section} from "./section.model";
import {TagGroup} from "./tagGroup.model";


export class SearchAdResult {
    id: number;
    name: string;

    tag_groups: TagGroup[]
    folders: Section[]
    collections: Section[]

    constructor(data?: Partial<SearchAdResult>) {
        this.id = data?.id || 0;
        this.name = data?.name || "";

        this.tag_groups = data?.tag_groups || [];
        this.folders = data?.folders || [];
        this.collections = data?.collections || [];
    }
}